import gql from 'graphql-tag';

export const ASSET_FILE_DELETE = gql`
    mutation assetFileDelete($input:  AssetFileDeleteMutationInput!) {
        assetFileDelete (input: $input) {
            assetFile {
                file { name }
            }
        }
    }`;